import React from "react";
import { Bar } from "@ant-design/charts";
import {useTranslation} from "react-i18next";

export const CategoriesBarChart = ({ entries }) => {
  const {t} = useTranslation();
  if (!entries) {
    return null;
  }

  const colors = {
    CRB: "#f5222d",
    "Történelmi számszeríj": "#f5222d",
    "Historical crossbows": "#f5222d",
    CU: "#fa8c16",
    C: "#fa8c16",
    FU: "#fa8c16",
    "FS(C)": "#fa8c16",
    "Csigás íj": "#fa8c16",
    HU: "#faad14",
    "BH(C)": "#faad14",
    BU: "#faad14",
    CB: "#fa541c",
    OL: "#52c41a",
    R: "#52c41a",
    "FS(R)": "#52c41a",
    "BB(R)": "#52c41a",
    "Modern reflexíj": "#52c41a",
    BB: "#13c2c2",
    "Történelmi (természetes)": "#13c2c2",
    "Historical (natural)": "#13c2c2",
    "BB(C)": "#13c2c2",
    B: "#13c2c2",
    TRRB: "#1890ff",
    HR: "#1890ff",
    "BH(R)": "#1890ff",
    "Vadászíj": "#1890ff",
    "Hunting bows": "#1890ff",
    TRLB: "#eb2f96",
    "Történelmi hosszúíjak és egyéb botíjak": "#eb2f96",
    "Historical longbow": "#eb2f96",
    LB: "#eb2f96",
    BL: "#eb2f96",
    PBHB: "#722ed1",
    "Történelmi (modern)": "#722ed1",
    "Historical (modern)": "#722ed1",
    HB: "#722ed1",
    TR: "#722ed1",
    TRB: "#722ed1",
    "Történelmi íj": "#722ed1",
  };

  const categoryMap = {};

  entries.forEach((entry) => {
    let categoryName = t(entry.category.name);
    if (!categoryMap[categoryName]) {
      categoryMap[categoryName] = 1;
    } else {
      categoryMap[categoryName] += 1;
    }
  });

  const options = {
    legend: false,
    colorField: "category", // 部分图表使用 seriesField
    color: ({ category }) => {
      return colors[category] || "#1890ff";
    },
    height: 35,
    xField: "count",
    xAxis: false,
    yAxis: false,
    yField: "group",
    seriesField: "category",
    isStack: true,
    label: {
      position: "middle",
      content: function content(item) {
        return item.category;
      },
      style: { fill: "#fff" },
    },
  };

  const getData = () => {
    let data = Object.entries(categoryMap).map(([category, count]) => ({
      category,
      count,
      group: "Kategóriák",
    }));

    data.sort((a, b) => a.count - b.count);

    return data;
  };

  return <Bar {...options} data={getData()} />;
};
